import React from 'react';
import PropTypes from 'prop-types';
import {Box, Heading, Image, Text, useBreakpointValue} from '@chakra-ui/react';

const BannerHomepage = ({bannerData}) => {
    BannerHomepage.propTypes = {
        bannerData: PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            image: PropTypes.string.isRequired,
            mobileImage: PropTypes.string.isRequired,
        }),
    };

    const isMobile = useBreakpointValue({base: true, md: false});

    return (
        <div className="banner-homepage">
            <Box w="100%" className="banner-homepage-text">
                {/* Conditionally render the purple box for mobile */}
                {isMobile && (
                    <Box
                        position="relative"
                        top="81px"
                        left="0"
                        right="0"
                        bg="#1A1A42"
                        p="4"
                        zIndex="1"
                        color="#FFFFFF"
                    >
                        <Heading variant="heading1" >
                            {bannerData.title}
                        </Heading>
                        <Text textStyle="bannerText">
                            {bannerData.description}
                        </Text>
                    </Box>
                )}

                {/* Hero Image */}
                <Image
                    src={isMobile ? bannerData.mobileImage : bannerData.image}
                    alt="Banner Hero"
                    objectFit="cover"
                    width="100%"
                    height={isMobile ? "auto" : "795px"}
                    style={{transform: 'scaleX(-1)'}}
                />

                {/* Desktop Text */}
                {!isMobile && (
                    <Box
                        position="absolute"
                        top="0"
                        left="12%"
                        width="40%"
                        height="100%"
                        padding="4"
                        display="flex"
                        flexDirection="column"
                        justifyContent="center"
                        alignItems="left"
                        color="#FFFFFF"
                    >
                        <Heading variant="heading1" py="10">
                            {bannerData.title}
                        </Heading>
                        <Text textStyle="bannerText" w="471px">
                            {bannerData.description}
                        </Text>
                    </Box>
                )}
            </Box>
        </div>
    );
};

export default BannerHomepage;